import React, { useState } from 'react';
import { IMobilePaymentDetail } from '@components/Sura/PaymentDetails/Mobile/types';
import { observer } from 'mobx-react';
import { IconButton, Card, Typography } from '@material-ui/core';
import useStyles from '@components/Sura/PaymentDetails/Mobile/styles';
import HeaderTotal from '@components/Sura/PaymentDetails/HeaderTotal';
import Contracts from '@components/Sura/PaymentDetails/Contracts';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import useStore from '@hooks/useStore';

const MobilePaymentDetail: React.FC<IMobilePaymentDetail> = () => {
  const [open, setOpen] = useState<boolean>(false);
  const { ui } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });

  const handleExpandDetail = () => {
    setOpen((prev) => !prev);
  };

  return (
    <React.Fragment>
      <div className={css.root}>
        <Card className={css.card}>
          <HeaderTotal />
          {!open && (
            <div className={css.divIcon}>
              <IconButton onClick={handleExpandDetail}>
                <ExpandMoreIcon className={css.iconStyle} />
                <Typography className={css.labelReceipt}>Ver más</Typography>
              </IconButton>
            </div>
          )}
          {open && (
            <>
              <Contracts />
              <div className={css.divIcon}>
                <IconButton onClick={handleExpandDetail}>
                  <ExpandLessIcon className={css.iconStyle} />
                  <Typography className={css.labelReceipt}>Ocultar</Typography>
                </IconButton>
              </div>
            </>
          )}
        </Card>
      </div>
    </React.Fragment>
  );
};

export default observer(MobilePaymentDetail);
